import Curriculum from './curriculum.js'

window.Curriculum = Curriculum
